// src/config/siteConfig.js
export const SITE_CONFIG = {
  name: "ChatoraHack Lottery",
  url: "https://lottery.chatorahack.com",
  ogpImage: "/ogp.png",
  description:
    "数字選択式宝くじ（ロト・ナンバーズ・ビンゴ5）の抽選結果・当選番号・払戻金を公開し、配当金と出目の関係など過去データの統計的な分析・研究を行う無料の情報サイトです。当選予想・攻略ツールではありません。",
  icon: "/favicon.ico",
  logo: "/logo192.png",
  contact: {
    formUrl:
      "https://docs.google.com/forms/d/e/1FAIpQLSfEAEWstoZZmx_Gyc8JL-uM-8npguBxA1b4Ul5fiqZBTq8v1Q/viewform?usp=header", // 後で差し替え
  },
  sns: {
    x: "https://x.com/chatorahack",
  },
  author: "ChatoraHack",
  license: "GNU GPL v3",
};
